import Aos from "aos";
import React, { useState, useRef, useEffect } from "react";
import video from "../../assets/handiversePromo.mp4";
import useElementOnScreen from "../../helpers/UseElementOnScreen";
import { FaRegPlayCircle } from "react-icons/fa";
function Airdrop(props) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.3,
  };
  const isVisibile = useElementOnScreen(options, videoRef);
  const onVideoClick = () => {
    if (playing) {
      videoRef.current.pause();
      setPlaying(!playing);
    } else {
      videoRef.current.play();
      setPlaying(!playing);
    }
  };
  useEffect(() => {
    if (isVisibile) {
      if (!playing) {
        videoRef.current.play();
        setPlaying(true);
      }
    } else {
      if (playing) {
        videoRef.current.pause();
        setPlaying(false);
      }
    }
  }, [isVisibile]);

  return (
    <div className="bg-[#04091a] flex flex-col md:flex-row mt-20 md:mt-5 justify-around">
      <video
        loop
        preload="true"
        autoPlay
        playsInline
        muted
        controls
        ref={videoRef}
        onClick={onVideoClick}
        src={video}
        id="promo-video"
      ></video>
      {/* {!playing && (
        <FaRegPlayCircle
          className="play_icon"
          color="white"
          size={100}
          onClick={onVideoClick}
        />
      )} */}
    </div>
  );
}

export default Airdrop;
